module.exports = __webpack_public_path__ + "static/img/11.daec7da.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/hotKeywordsMap/map/11.png
// module id = 1DKj
// module chunks = 2